import {captureException} from "@sentry/react";
import {useFrontContext} from "v4/contexts/FrontContext";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import {getLSItem} from "v4/services/localStorage.service";
import {toCapitalize} from "v4/utils";

export default function useHandleDefaultSearchFilters() {
    const {isProspectTab} = useFrontContext();
    const {currentRoute} = useNavigation();
    const entityOrTabId = currentRoute.isCustomTab ? currentRoute.route.metadata.tab_id : toCapitalize(currentRoute.route.search_type);
    const {defaultSearchFilters} = getLSItem('user');
    let defaultFilters = {};

    try {
        defaultFilters = JSON.parse(defaultSearchFilters);
    } catch (e) {
        captureException(e, {
            extra: {
                defaultSearchFilters,
            }
        });
    }

    return {
        ...defaultFilters[isProspectTab ? undefined : entityOrTabId],
    }
}
